"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMessageComposer = useMessageComposer;
var _react = require("react");
var _normalize = require("../core/normalize");
var _constants = require("../utils/constants");
const _excluded = ["broadcast"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
let tempIdCounter = 0;
function nextTempId() {
  tempIdCounter += 1;
  return "tmp_".concat(Date.now(), "_").concat(tempIdCounter);
}

// Owns composer UI state (draft text, attachments, reply-to) and the
// optimistic-send/reconcile flow that replaces the old ad hoc `_id: null`
// placeholder + find-and-replace pattern with an explicit tempId/status.
//
// Deliberately generic about *what* gets sent: `buildMessagePayload` lets
// each channel (contact vs group vs task) map the shared draft shape onto its
// own REST fields (receiver, moduleslug, contactid, ...), and the optional
// `broadcast` passed to send() carries the socket room/receiver list — this
// keeps the hook itself channel-agnostic.
function useMessageComposer() {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    chatClient = _ref.chatClient,
    adapter = _ref.adapter,
    buildMessagePayload = _ref.buildMessagePayload,
    onOptimisticMessage = _ref.onOptimisticMessage,
    onMessageConfirmed = _ref.onMessageConfirmed,
    onMessageFailed = _ref.onMessageFailed;
  const _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    messageText = _useState2[0],
    setMessageText = _useState2[1];
  const _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    uploadedFiles = _useState4[0],
    setUploadedFiles = _useState4[1];
  const _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    uploadedFileIds = _useState6[0],
    setUploadedFileIds = _useState6[1];
  const _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isUploading = _useState8[0],
    setIsUploading = _useState8[1];
  const _useState9 = (0, _react.useState)(0),
    _useState0 = _slicedToArray(_useState9, 2),
    uploadedFileCount = _useState0[0],
    setUploadedFileCount = _useState0[1];
  const _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    fileTooBig = _useState10[0],
    setFileTooBig = _useState10[1];
  const _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    parentMessageId = _useState12[0],
    setParentMessageId = _useState12[1];
  const _useState13 = (0, _react.useState)(""),
    _useState14 = _slicedToArray(_useState13, 2),
    replyUserName = _useState14[0],
    setReplyUserName = _useState14[1];
  const _useState15 = (0, _react.useState)(""),
    _useState16 = _slicedToArray(_useState15, 2),
    replyMessage = _useState16[0],
    setReplyMessage = _useState16[1];
  const _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isSending = _useState18[0],
    setIsSending = _useState18[1];
  const resetComposer = (0, _react.useCallback)(() => {
    setMessageText("");
    setUploadedFiles([]);
    setUploadedFileIds([]);
    setUploadedFileCount(0);
    setFileTooBig(false);
    setParentMessageId(null);
    setReplyUserName("");
    setReplyMessage("");
  }, []);
  const setReply = (0, _react.useCallback)((message, senderLabel) => {
    var _message$id, _message$translation;
    setParentMessageId((_message$id = message.id) !== null && _message$id !== void 0 ? _message$id : message.tempId);
    setReplyMessage(((_message$translation = message.translation) === null || _message$translation === void 0 ? void 0 : _message$translation.body) || message.body);
    setReplyUserName(senderLabel);
  }, []);
  const clearReply = (0, _react.useCallback)(() => {
    setParentMessageId(null);
    setReplyUserName("");
    setReplyMessage("");
  }, []);
  const uploadFiles = (0, _react.useCallback)(async fileList => {
    const files = Array.from(fileList || []);
    if (files.length === 0) return;
    const tooBig = files.some(file => file.size > _constants.MAX_UPLOAD_FILE_SIZE_BYTES);
    if (tooBig) {
      setFileTooBig(true);
      return;
    }
    setFileTooBig(false);
    setIsUploading(true);
    setUploadedFileCount(files.length);
    try {
      const response = await chatClient.uploadFiles(files);
      setUploadedFiles(prev => prev.concat(response.data));
      setUploadedFileIds(prev => prev.concat(response.data.map(_ref2 => {
        let _id = _ref2._id;
        return {
          _id
        };
      })));
    } finally {
      setIsUploading(false);
      setUploadedFileCount(0);
    }
  }, [chatClient]);
  const removeUploadedFile = (0, _react.useCallback)(index => {
    setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    setUploadedFileIds(prev => prev.filter((_, i) => i !== index));
  }, []);
  const send = (0, _react.useCallback)(async function () {
    let extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const broadcast = extra.broadcast,
      restPayloadFields = _objectWithoutProperties(extra, _excluded);
    const trimmedBody = messageText.trim();
    if (!trimmedBody && uploadedFiles.length === 0) return undefined;
    const tempId = nextTempId();
    const draft = {
      body: trimmedBody,
      attachments: uploadedFiles,
      parent: parentMessageId,
      parentMessage: replyMessage,
      parentSender: replyUserName
    };
    onOptimisticMessage === null || onOptimisticMessage === void 0 || onOptimisticMessage((0, _normalize.createOptimisticMessage)(_objectSpread(_objectSpread({
      tempId
    }, draft), restPayloadFields)));
    const payload = buildMessagePayload ? buildMessagePayload(_objectSpread(_objectSpread({}, draft), {}, {
      uploads: uploadedFileIds,
      tempId
    }, restPayloadFields)) : _objectSpread({
      description: trimmedBody,
      uploads: uploadedFileIds,
      parent: parentMessageId
    }, restPayloadFields);
    resetComposer();
    setIsSending(true);
    try {
      const response = await chatClient.sendMessage(payload);
      onMessageConfirmed === null || onMessageConfirmed === void 0 || onMessageConfirmed(tempId, response.data);
      if (broadcast) {
        adapter === null || adapter === void 0 || adapter.sendMessage({
          chatroomid: broadcast.chatroomid,
          messageData: response.data,
          receiverlist: broadcast.receiverlist
        });
      }
      return response.data;
    } catch (error) {
      onMessageFailed === null || onMessageFailed === void 0 || onMessageFailed(tempId, error);
      throw error;
    } finally {
      setIsSending(false);
    }
  }, [messageText, uploadedFiles, uploadedFileIds, parentMessageId, replyMessage, replyUserName, buildMessagePayload, chatClient, adapter, onOptimisticMessage, onMessageConfirmed, onMessageFailed, resetComposer]);
  return {
    messageText,
    setMessageText,
    uploadedFiles,
    uploadedFileIds,
    isUploading,
    uploadedFileCount,
    fileTooBig,
    parentMessageId,
    replyUserName,
    replyMessage,
    isSending,
    setReply,
    clearReply,
    uploadFiles,
    removeUploadedFile,
    send,
    resetComposer
  };
}